import $ from 'jquery'
export default {
  name: 'create',
  components: {},
  props: [],
  data () {
    return {
      maladie: null,
      maladies: [],
      dossierMedical:{
        maladies: [],
      }

    }
  },
  computed: {

  },
  mounted () {
    setTimeout(() => {
      $('.shw').fadeIn()
    }, 1500);
  },
  methods: {
    nextAntPersonnel: function(){
      this.$refs.antecedents_familiaux.click()
    },
    nextAntFamiliaux: function(){
      this.$refs.vaccinations.click()
    },
    previousAntFamiliaux: function(){
      this.$refs.antecedents_personnels.click()
    },
    previousVaccinations: function(){
      this.$refs.antecedents_familiaux.click();
    },
    addWrittenMaladiesToList: function(){
      console.log("here")
      this.maladies.push(this.maladie)
    }

  }
}


